// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_fw","gallery__header":"c-q_fx","gallery__thumbs":"c-q_fy"};